var _defs, _path, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContainerSeries01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 900 414.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-3{fill:#333;opacity:.5}.cls-8{letter-spacing:-.11em}.cls-10,.cls-11{letter-spacing:-.02em}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M18 13.25h857v24H18zM18 64.97h857v24H18zM18 116.69h857v24H18zM18 195.42h857v24H18zM18 273h857v24H18zM18 325.58h857v24H18zM18 377.31h857v24H18z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "translate(25.38 31.19)",
    fontFamily: "HelveticaNeue-Medium,'Helvetica Neue'",
    fontSize: 18,
    fontWeight: 500,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Body "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 48.69,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 57.37,
    y: 0
  }, "ype"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 26
  }, "Manholes"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 0,
    y: 52
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 8.68,
    y: 52
  }, "est P"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 51.03,
    y: 52
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 57.04,
    y: 52
  }, "essu"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 96.06,
    y: 52
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 102.08,
    y: 52
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 78
  }, "Operating P"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 99.38,
    y: 78
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 105.39,
    y: 78
  }, "essu"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 144.41,
    y: 78
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 150.42,
    y: 78
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 104
  }, "Operating "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 87.37,
    y: 104
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 96.05,
    y: 104
  }, "emperatu"), /*#__PURE__*/React.createElement("tspan", {
    x: 175.39,
    y: 104,
    letterSpacing: "-.02em"
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 181.4,
    y: 104
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 130
  }, "Discharge"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 182,
    letterSpacing: "-.04em"
  }, "W"), /*#__PURE__*/React.createElement("tspan", {
    x: 16.33,
    y: 182
  }, "alkway"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 208
  }, "Container Frame"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 0,
    y: 260
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 8.68,
    y: 260
  }, "est"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 286
  }, "Surface "), /*#__PURE__*/React.createElement("tspan", {
    x: 69.03,
    y: 286,
    letterSpacing: "-.09em"
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 78.05,
    y: 286
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 84.06,
    y: 286
  }, "eatment"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 312
  }, "G"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 13.66,
    y: 312
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 19.67,
    y: 312
  }, "oss "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 54.04,
    y: 312
  }, "W"), /*#__PURE__*/React.createElement("tspan", {
    x: 70.7,
    y: 312
  }, "eight"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 338,
    letterSpacing: "-.1em"
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 8.87,
    y: 338
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 18.88,
    y: 338
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 24.89,
    y: 338
  }, "e "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 39.91,
    y: 338
  }, "W"), /*#__PURE__*/React.createElement("tspan", {
    x: 56.57,
    y: 338
  }, "eight"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 364
  }, "Payload Capacity"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(279.38 31.33)",
    fill: "#fff",
    fontFamily: "HelveticaNeue,'Helvetica Neue'",
    fontSize: 17
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Aluminium "), /*#__PURE__*/React.createElement("tspan", {
    x: 84.42,
    y: 0,
    letterSpacing: "-.11em"
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 92.29,
    y: 0
  }, "ank"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 26
  }, "2 x DN450 aluminum covers with 4 clamps"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 52
  }, "3 bar"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 78
  }, "2 bar"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 104
  }, "-40\xB0C / +80\xB0C"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 130
  }, "A 2 bar pneumatic discha"), /*#__PURE__*/React.createElement("tspan", {
    x: 194.31,
    y: 130,
    letterSpacing: "-.03em"
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 199.49,
    y: 130
  }, "ge system with a DN 800 elect"), /*#__PURE__*/React.createElement("tspan", {
    x: 430.93,
    y: 130,
    letterSpacing: "-.02em"
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 436.28,
    y: 130
  }, "o-polished stainless "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 156
  }, "steel discha"), /*#__PURE__*/React.createElement("tspan", {
    x: 90.68,
    y: 156,
    letterSpacing: "-.03em"
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 95.86,
    y: 156
  }, "ge cone and a DN 150 butterfly valve"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 182
  }, "Aluminum safety platform and aluminum ladder"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 208,
    letterSpacing: "-.06em"
  }, "W"), /*#__PURE__*/React.createElement("tspan", {
    x: 14.77,
    y: 208
  }, "elded construction with aluminum alloy suspension, aluminum container "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 234
  }, "co"), /*#__PURE__*/React.createElement("tspan", {
    x: 18.89,
    y: 234,
    letterSpacing: ".02em"
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 24.85,
    y: 234
  }, "ners, and stacking p"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 179.16,
    y: 234
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 184.52,
    y: 234
  }, "otection on the chassis"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 260
  }, "CSC App"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 71.47,
    y: 260
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 76.82,
    y: 260
  }, "oval, UIC railway code"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 286
  }, "2 layers of epoxy primer and 2 layers of acrylic paint with a baked-on finish"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 312
  }, "32.200 kg"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 338
  }, "3.000 kg"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 364
  }, "29.200 kg"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContainerSeries01);
export default __webpack_public_path__ + "static/media/ContainerSeries-01.f56a02347df920f75ef13ace77d3e0e7.svg";
export { ForwardRef as ReactComponent };